/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSectionContentQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetSectionContentInput>;
}>;


export type GetSectionContentQuery = { __typename?: 'Query', getSectionContent?: Array<{ __typename?: 'ContentSection', alignment: Types.ContentSectionAlignment, content: string, location: Types.ContentSectionLocation, placement: Types.ContentSectionPlacement, id: string, subheading?: string | null, title?: string | null } | null> | null };


export const GetSectionContentDocument = gql`
    query GetSectionContent($input: GetSectionContentInput) {
  getSectionContent(input: $input) {
    alignment
    content
    location
    placement
    id
    subheading
    title
  }
}
    `;

/**
 * __useGetSectionContentQuery__
 *
 * To run a query within a React component, call `useGetSectionContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSectionContentQuery(baseOptions?: Apollo.QueryHookOptions<GetSectionContentQuery, GetSectionContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSectionContentQuery, GetSectionContentQueryVariables>(GetSectionContentDocument, options);
      }
export function useGetSectionContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSectionContentQuery, GetSectionContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSectionContentQuery, GetSectionContentQueryVariables>(GetSectionContentDocument, options);
        }
export function useGetSectionContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSectionContentQuery, GetSectionContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSectionContentQuery, GetSectionContentQueryVariables>(GetSectionContentDocument, options);
        }
export type GetSectionContentQueryHookResult = ReturnType<typeof useGetSectionContentQuery>;
export type GetSectionContentLazyQueryHookResult = ReturnType<typeof useGetSectionContentLazyQuery>;
export type GetSectionContentSuspenseQueryHookResult = ReturnType<typeof useGetSectionContentSuspenseQuery>;
export type GetSectionContentQueryResult = Apollo.QueryResult<GetSectionContentQuery, GetSectionContentQueryVariables>;